import { defineComponent as h, inject as b, openBlock as t, createElementBlock as r, Fragment as n, renderList as i, createBlock as a, normalizeClass as d, unref as m } from "vue";
import { _ as u } from "./RectangleSkeleton.vue_vue_type_script_setup_true_lang-c9a909e1.mjs";
import "./convertNumberToPixel-9f7a4488.mjs";
const p = { class: "[&>div:nth-child(2n+3)]:max-w-[75%] [&>div:nth-child(3n+2)]:max-w-[45%]" }, g = {
  key: 0,
  class: "w-full"
}, _ = /* @__PURE__ */ h({
  __name: "TextSkeleton",
  props: {
    textSmall: { type: Boolean },
    textLinesCount: {},
    textLinesWidth: {},
    width: {},
    color: { default: "rgba(0, 0, 0, 0.06)" },
    align: {},
    borderRadius: {}
  },
  setup(k) {
    const s = b("marginClass", "");
    return (e, f) => {
      var l;
      return t(), r("div", p, [
        (l = e.textLinesWidth) != null && l.length ? (t(), r("div", g, [
          (t(!0), r(n, null, i(e.textLinesWidth, (o, c) => (t(), a(u, {
            key: c,
            class: d([[m(s)], "skeleton mb-8 last:mb-0"]),
            color: e.color,
            height: e.textSmall ? "1.2rem" : "2rem",
            width: o,
            borderRadius: e.borderRadius
          }, null, 8, ["class", "color", "height", "width", "borderRadius"]))), 128))
        ])) : (t(!0), r(n, { key: 1 }, i(e.textLinesCount, (o) => (t(), a(u, {
          key: o,
          class: d([[m(s)], "skeleton mb-8 last:mb-0"]),
          color: e.color,
          height: e.textSmall ? "1.2rem" : "2rem",
          borderRadius: e.borderRadius
        }, null, 8, ["class", "color", "height", "borderRadius"]))), 128))
      ]);
    };
  }
});
export {
  _ as default
};
